import React from 'react';

type LinkToNewTabKeepContextProps = {
    link: string;
    displayInline?: boolean;
    callback?: (() => void) | null;
};
export const LinkToNewTabKeepContext: React.FC<LinkToNewTabKeepContextProps> = ({link, displayInline = false, callback, children}) => {
    const open = () => {
        if (callback) {
            callback();
        }

        window.open(link);
    }
    return (
        <div onClick={open} className={`cursor-pointer ${displayInline ? "inline-block" : ""}`}>
            {children}
        </div>
    );
}
